// @ts-nocheck
import React, { useEffect } from 'react';
import { useAuthData } from '@ywfe/authmodules';
import { LoginScanStyle } from './styles';

export const LoginWxScan: React.FC<{ id?: string }> = ({ id = 'login_wx_container' }) => {
  const { dataGetWxCode } = useAuthData();
  useEffect(() => {
    dataGetWxCode(window.location.href, 'YW_YUN', id, 'PC');
  }, []);

  return (
    <LoginScanStyle>
      <div id={id} />
    </LoginScanStyle>
  );
};
